import Endpoints from 'constants/Endpoints';
import {RestRequestBLOB, RestRequestDELETE, RestRequestGET, RestRequestPOST} from 'libs/RestRequest';

const formatValues = (values) => {
    return ({
        ...values,
        startDate: values.startDate.format(),
        endDate: values.endDate ? values.endDate.format() : null
    })
}

const create = async (demandId, roundId, values) => {
    return await RestRequestPOST(Endpoints.AUCTION_CREATE(demandId, roundId), formatValues(values));
};

const editDates = async (demandId, roundId, values) => {
    return await RestRequestPOST(Endpoints.AUCTION_EDIT_DATES(demandId, roundId), formatValues(values));
};

const publish = async (demandId, roundId, values) => {
    return await RestRequestPOST(Endpoints.AUCTION_PUBLISH(demandId, roundId), values);
};

const unpublish = async (demandId, roundId, values) => {
    return await RestRequestPOST(Endpoints.AUCTION_UNPUBLISH(demandId, roundId), values);
};

const pause = async (demandId, roundId, values) => {
    return await RestRequestPOST(Endpoints.AUCTION_PAUSE(demandId, roundId), values);
};
const resume = async (demandId, roundId, values) => {
    return await RestRequestPOST(Endpoints.AUCTION_RESUME(demandId, roundId), values);
};

const cancel = async (demandId, roundId, values) => {
    return await RestRequestPOST(Endpoints.AUCTION_CANCEL(demandId, roundId), values);
};

const remove = async (demandId, roundId, values) => {
    return await RestRequestDELETE(Endpoints.AUCTION_DELETE(demandId, roundId), {data: values});
};

const prepare = async (demandId, roundId, netOverGross) => {
    return await RestRequestGET(Endpoints.AUCTION_PREPARE(demandId, roundId) + (netOverGross != null ? '?useNetOverGross=' + netOverGross : ''));
};
const accept = async (demandId, roundId, auctionId) => {
    return await RestRequestGET(Endpoints.AUCTION_ACCEPT(demandId, roundId, auctionId));
};

const details = async (demandId, roundId, auctionId) => {
    return await RestRequestGET(Endpoints.AUCTION_DETAILS(demandId, roundId, auctionId));
};

const downloadAuctionInvitation = async (demandId, roundId, finallyCallback = () => {
}) => {
    try {
        RestRequestBLOB(Endpoints.AUCTION_DOWNLOAD_INVITATION(demandId, roundId))
            .finally(finallyCallback);
    } catch (error) {
    }
};

export default {
    prepare,
    create,
    cancel,
    remove,
    editDates,
    publish,
    unpublish,
    pause,
    resume,
    accept,
    details,
    downloadAuctionInvitation
}